import { useSearchParams } from "react-router-dom"
import { AdminQueryParams } from "@type/staticData.types"
import { useMemo } from "react"

const useAdminQueryParams = () => {
	const [searchParams, setSearchParams] = useSearchParams()

	const params = useMemo(() => {
		return Object.fromEntries(searchParams.entries()) as Partial<AdminQueryParams>
	}, [searchParams])

	const setSearchParamsWithReplace = (newParams: Partial<AdminQueryParams>) => {
		const { tab = "", selected = "", platform = "" } = { ...params, ...newParams }
		setSearchParams({ tab, ...(!!platform && { platform }), selected }, { replace: true })
	}

	const setSearchParamsWithHistory = (newParams: Partial<AdminQueryParams>) => {
		setSearchParams({ ...params, ...newParams }, { replace: false })
	}

	return {
		params,
		setSearchParams: setSearchParamsWithReplace,
		setSearchParamsWithHistory,
	}
}

export default useAdminQueryParams
